@if (isVisible()) {
  <div
    class="learnosity-overlay"
    [class.learnosity-overlay--closing]="isClosing()"
    role="dialog"
    aria-modal="true"
    aria-label="Learnosity oefening"
    #overlayPanel
    tabindex="-1"
    (animationend)="isClosing() && onLeaveAnimationEnd()"
  >
    @if (overlayData; as data) {
      <campus-learnosity-dialog
        [config]="data.config"
        [component]="data.component"
        [eduContent]="eduContent"
      ></campus-learnosity-dialog>
    }
  </div>
}
